import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chatData, setChatData] = useState(null);
  const [networkError, setNetworkError] = useState(false);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("ecode", userData.ecode);
  };

  const logout = () => {
    setUser(null);
    setChatData(null);
    localStorage.removeItem("ecode");
  };

  const fetchChatData = async () => {
    if (user?.chat_id) {
      try {
        const res = await fetch("https://kracet.shop/mastapi/chatdata.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chatid: user.chat_id }),
        });

        const data = await res.json();
        if (res.ok && data.success) {
          setChatData(data.data);
        }
      } catch (error) {
        console.error("Failed to fetch chat data:", error);
      }
    }
  };

  const fetchUserData = async () => {
    const storedEcode = localStorage.getItem("ecode");
    if (!storedEcode) return;

    try {
      const res = await fetch("https://kracet.shop/mastapi/valecode.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ecode: storedEcode }),
      });

      const data = await res.json();

      if (res.ok && data.success && data.user.ecode === storedEcode) {
        setUser(data.user);
      }
    } catch (error) {
      console.error("Failed to refresh user data:", error);
    }
  };

  const validateEcode = async () => {
    const storedEcode = localStorage.getItem("ecode");

    if (!storedEcode) {
      setLoading(false);
      return false;
    }

    if (!navigator.onLine) {
      console.warn("Device is offline. Skipping ecode validation.");
      setUser({ ecode: storedEcode });
      setNetworkError(true);
      setLoading(false);
      return true;
    }

    try {
      const res = await fetch("https://kracet.shop/mastapi/valecode.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ecode: storedEcode }),
      });

      const data = await res.json();

      if (res.ok && data.success && data.user.ecode === storedEcode) {
        setUser(data.user);
        return true;
      } else {
        logout();
        return false;
      }
    } catch (error) {
      console.error("Ecode validation failed:", error);
      setNetworkError(true);
      setUser({ ecode: storedEcode });
      return true;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    validateEcode();
  }, []);

  useEffect(() => {
    fetchChatData();
  }, [user]);

  return (
    <AuthContext.Provider
      value={{
        user,
        chatData,
        login,
        logout,
        loading,
        networkError,
        refreshChatData: fetchChatData,
        refreshUserData: fetchUserData,
        validateEcode, // Exposed for reuse
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
